module.exports = __webpack_public_path__ + "img/reward_700.5cf115a1.png";